import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NgbdCarousel } from './carousel';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './safe-html.pipe';

@NgModule({
  imports: [NgbModule, CommonModule],
  declarations: [NgbdCarousel, SafeHtmlPipe],
  exports: [NgbdCarousel]
})
export class NgbdCarouselBasicModule {}
